import { DarkMapLayer } from "../../layers/DarkMapLayer";
import { LightGreyMapLayer } from "../../layers/LightGreyMapLayer";
import { MapTilerBasicLayer } from "../../layers/MapTilerBasicLayer";
import { MapTilerCyclingLayer } from "../../layers/MapTilerCyclingLayer";
import { ShortCutClassicLayer } from "../../layers/ShortCutClassicLayer";
import { writable } from "svelte/store";
export class LayersToolBoxManager {
    constructor(toolBoxManager, mapillaryManager) {
        this.baseLayers = [
            {
                id: "basic",
                layer: new MapTilerBasicLayer(),
            },
            {
                id: "classic",
                layer: new ShortCutClassicLayer(),
            },
            {
                id: "cycling",
                layer: new MapTilerCyclingLayer(),
            },
            {
                id: "light",
                layer: new LightGreyMapLayer(),
            },
            {
                id: "dark",
                layer: new DarkMapLayer(),
            },
        ];
        this.imageryVisible = writable(false);
        this.activeBaseLayer = writable(this.baseLayers[3]);
        this.toolBoxManager = toolBoxManager;
        this.mapillaryManager = mapillaryManager;
        this.activeBaseLayer.subscribe(baseLayer => {
            if (typeof this.map === "undefined")
                return;
            this.map.toggleBaseLayer(baseLayer.layer);
        });
        this.imageryVisible.subscribe(imagery => {
            if (typeof this.map === "undefined")
                return;
            this.map.toggleImagery(imagery);
        });
    }
    addToMap(map) {
        this.map = map;
    }
    getDataLayerOptions() {
        return [
            {
                id: "mapillary",
                visible: this.mapillaryManager.getVisibleStore()
            }
        ];
    }
    getBaseLayers() {
        return this.baseLayers;
    }
    getImageryVisisbleStore() {
        return this.imageryVisible;
    }
    getOpenToolBoxStore() {
        return this.toolBoxManager.getOpenToolBoxStore();
    }
    getActiveBaseLayerStore() {
        return this.activeBaseLayer;
    }
}
